export default __webpack_public_path__ + "static/media/Pickpocket's Leggings of the Smoldering Throne.6b75da95.jpg";